module.exports = __webpack_public_path__ + "static/media/woman-empty.1fb007e1.png";